<template>
  <content-editor
    :fields="fields"
    :publication="true"
    permission="press"
    endpoint="press"
    @update="updateState"
    module="press"
    previewModule="pers"
    :selectTags="false"
    :selectCategories="false"
    />
</template>

<script>
import ContentEditor from '@/components/editor/content_blocks/ContentEditor.vue';
import ContentDetail from '@/mixins/contentEditor/Detail';

export default {
  mixins: [ContentDetail],
  data() {
    return {
      module: 'press',
      fields: [
        {
          name: 'notes',
          required: false,
        },
        {
          name: 'branches',
          required: true,
        },
        {
          name: 'lightbox',
          required: false,
        },
        {
          name: 'read-confirmation',
          required: false,
        },
        {
          name: 'title',
          required: true,
        },
        {
          name: 'url',
          required: true,
        },
        {
          name: 'status',
          required: true,
        },
        {
          name: 'recap',
          required: false,
        },
        {
          name: 'targets',
          required: true,
        },
        {
          name: 'image',
          required: true,
        },
        {
          name: 'seo_keywords',
          required: false,
        },
      ],
    };
  },
  components: {
    ContentEditor,
  },
};
</script>
